<template>

  <div class="article-page">
    <main-navbar type="9"></main-navbar>
    <div class="container">
      <div>
        <main-menu></main-menu>
      </div>
      <div class="row">
        <!--        <div class="col-sm-3 d-none d-sm-block menu-group">-->
        <left-bar type="1"></left-bar>
        <!--        </div>-->

        <div class="col-sm-9 col-12 " v-if="!articleDetail.status">
          <group-header :groupID="Number($route.params.groupid)"></group-header>
          <div style="padding-top: 106px;color:#6C7580" class="devnotice m-auto text-center  mb-4 ">
            <!--            <img class="mt-4" src="/img/private1.svg" alt="海外" height="102">-->
            <h5>{{ articleDetail.error }}</h5>
          </div>
        </div>

        <div class="col-sm-9 col-12 pb-4 bg-group" v-else>
          <group-header :groupID="Number($route.params.groupid)"></group-header>
          <div class="bg-content" v-if="articleDetail.status">
            <div>
              <div class="mt-3">
                <el-dialog
                    title="将本文转至以下任意话题"
                    :visible.sync="centerDialogVisible"
                    width="40%"
                    center>
                  <el-checkbox-group v-model="tagsList">
                    <el-checkbox
                        :label="item.tagID"
                        :key="item.tagID"
                        class="float-left"
                        v-for="item in tags">
                      {{ item.tag_tagID.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                  <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeTopic">确 定</el-button>
                 </span>
                </el-dialog>
              </div>
              <h4 class="d-inline-block mr-3">{{ articleDetail.data.postInfo_postID.title|textTrans }}
                <span
                    v-if="articleDetail.data.is_publish===0 && articleDetail.data.is_sticky===0"
                    class="text-muted">（{{ $t('message').article.group_hide_text }}）
              </span>
                <!--            设置-->
                <el-dropdown trigger="click"
                             v-if="$store.state.group.groupTopBar.auth>1 || $store.state.user.userinfo.id===articleDetail.data.userinfo_userID.id || $store.state.user.userinfo.UserLevel==6
">
                    <span class="el-dropdown-link mt-0 pt-0">
      <!--                <el-tooltip content="更多操作" placement="top" effect="light">-->
                       <i size="medium" class="el-icon-more trans ml-2"></i>
                      <!--                </el-tooltip>-->
                    </span>
                  <el-dropdown-menu slot="dropdown">
                    <!--              群主可见 未推荐时-->
                    <!-- <el-dropdown-item v-if="$store.state.group.groupTopBar.auth>1"> -->
                    <el-popconfirm v-if="!articleDetail.data.is_sticky&&$store.state.group.groupTopBar.auth>1 || $store.state.user.userinfo.UserLevel==6"
                                   placement="top-end"
                                   :confirm-button-text="'确定'"
                                   :cancel-button-text="$t('message').article.comment_cancel"
                                   :title="'确定将此文转至推广帖吗？'"
                                   :hide-icon="true"
                                   @confirm="article_sticky(articleDetail.data.postID,1)">
                      <!-- <a href="javascript:void(0)" slot="reference" style="color:gray;"> -->
                      <el-dropdown-item
                          slot="reference">
                        <i size="medium" class="el-icon-document"></i>
                        推至首页推广置顶
                      </el-dropdown-item>
                      <!-- </a> -->
                    </el-popconfirm>
                    <!-- 群主可见 已推荐后 -->
                    <el-popconfirm v-if="articleDetail.data.is_sticky&&$store.state.group.groupTopBar.auth>1"
                                   placement="top-end"
                                   :confirm-button-text="'确定'"
                                   :cancel-button-text="$t('message').article.comment_cancel"
                                   :title="'确定将此帖从推广贴页撤下吗？'"
                                   :hide-icon="true"
                                   @confirm="article_sticky(articleDetail.data.postID,0)">

                      <!-- <a href="javascript:void(0)" slot="reference" style="color:gray;"> -->
                      <el-dropdown-item
                          slot="reference">
                        <i size="medium" class="el-icon-document"></i>
                        撤销推广
                      </el-dropdown-item>
                      <!-- </a> -->
                    </el-popconfirm>
                    <span style="color:gray;display: block;" @click="centerDialogVisible = true"
                          v-if="$store.state.group.groupTopBar.auth>1|| $store.state.user.userinfo.id===articleDetail.data.userinfo_userID.id || $store.state.user.userinfo.UserLevel==6">
                  <el-dropdown-item>

                     <span style="font-size:17px;font-weight:200" class="mr-2"> #</span>话题管理

                  </el-dropdown-item>
                </span>

                    <!--              成员可见-->
                    <span style="color:gray;" @click="gotoEditor()">
                  <el-dropdown-item
                      v-if="$store.state.group.groupTopBar.auth>1||$store.state.user.userinfo.id===articleDetail.data.userinfo_userID.id || $store.state.user.userinfo.UserLevel==6">
                      <i size="medium" class="el-icon-edit"></i>
                      {{ $t('message').article.edit }}

                  </el-dropdown-item>
                </span>
                    <el-popconfirm
                        v-if="$store.state.group.groupTopBar.auth>1||$store.state.user.userinfo.id===articleDetail.data.userinfo_userID.id || $store.state.user.userinfo.UserLevel==6"
                        placement="top-end"
                        confirm-button-text='删除'
                        cancel-button-text='取消'
                        title="确定删除此帖吗？"
                        :hide-icon="true"
                        @confirm="article_delete(articleDetail.data)"
                    >
                      <!--                   placement="top-end">-->
                      <!--                  :confirm-button-text="$t('message').article.comment_delet"-->
                      <!--                  :cancel-button-text="$t('message').article.comment_cancel"-->
                      <!--                  :title="'确定删除此帖子吗？'"-->
                      <!--                  :hide-icon="true"-->
                      <!--                  style="color:#333"-->
                      <!--                  @confirm="article_delete(articleDetail.data)">-->
                      <el-dropdown-item slot="reference" icon="el-icon-delete">删除</el-dropdown-item>
                    </el-popconfirm>
                  </el-dropdown-menu>
                </el-dropdown>
                <!--            设置-->
              </h4>


              <div class="d-flex justify-content-between align-items-center">
              <span class="groupger-box">
                <member-list-item class="article" :data="articleDetail.data" type="small"
                                  @opendialog="$refs.dialog.isLogin()">
                </member-list-item>

              </span>
                <div class="d-flex align-items-center">
                  <div style="color:gray;">{{ articleDetail.data.create_date * 1000 | formatDate }}</div>
                  <div style="color:gray;"
                       class="ml-3">{{
                      $t('message').article.read_count
                    }}{{ articleDetail.data.postInfo_postID.count_read }}
                  </div>
                  <div style="color:gray;"
                       class="ml-3">评论{{ articleDetail.data.postInfo_postID.count_comment }}</div>
                </div>

                <div class="media-icons">
                <span class="buzz_list" v-if="buzz_list.length>0" @click="buzzListTrigger=true">
                  <el-avatar :size="30" :src="item.userinfo_userID.avatar" v-for="item in buzz_list.slice(0,5)"
                             :key="item.userID"
                             style="margin-left:-10px;margin-bottom:-10px">{{ item.userinfo_userID.first_letter }}
                  </el-avatar> {{ buzz_list.length }}
                </span>
                  <button type="button"
                          class="btn btn-icon btn-round btn-neutral"
                          :title="$t('message').article.like_text" @click="like()">
                  <span v-if="articleDetail.data.postInfo_postID.is_buzz" style="fill:#39B8EB"
                        v-html="icons.like"></span>
                    <span v-if="!articleDetail.data.postInfo_postID.is_buzz" style=" stroke:#44753d"
                          v-html="icons.like_outline"></span>
                  </button>
                  <button v-if="!$store.state.user.check_is_wxc_domain()" type="button"
                          class="btn btn-icon btn-round btn-neutral"
                          :title="$t('message').article.bookmark_text" style="fill:#39B8EB" @click="bookmark()">
                    <span v-if="articleDetail.data.postInfo_postID.is_bookmark" v-html="icons.star"></span>
                    <span v-if="!articleDetail.data.postInfo_postID.is_bookmark" v-html="icons.star_outline"></span>
                  </button>

                  <el-popover
                      placement="top-end"
                      trigger="click"
                      v-model="share.showShareBar">
                    <el-popover style="display:inline-block"
                                placement="bottom-end"
                                width="400"
                                trigger="click"
                                visible-arrow="false"
                                v-model="share.wechatQR">
                      <div class="float-right" @click="share.wechatQR=false">
                        {{ $t('message').article.share_wechat_close }}
                      </div>
                      <div class="mt-4 ">{{ $t('message').article.share_wechat_text }}</div>
                      <div class="p-3 text-center">
                        <qrcode-vue :value="shareItem.url" :size="300" level="H"/>
                      </div>

                      <!-- <img style="margin: 0 95px;" :src="shareItem.QRcode" alt=""> -->
                      <a href="#" @click="share.showShareBar=false" slot="reference">
                        <span class="shareIcon" v-html="icons.wechat">
                      </span>
                      </a>
                    </el-popover>
                    <div class="shareIcons" style="display:inline">
                      <ShareNetwork
                          v-for="item in shareNetworks"
                          :key="item.network"
                          :network="item.network"
                          :url="shareItem.url"
                          :title="shareItem.title"
                          :description="shareItem.description"
                          quote=""
                          hashtags=""
                      >
                        <span class="shareIcon mr-1" v-html="item.icon" @click="share.showShareBar=false"></span>
                      </ShareNetwork>

                      <!-- copy -->

                      <a class="btn bg-white btn-info  p-1 ml-0 mr-0 mb-1" href="#" role="button" @click="copyUrl()">
                        <span v-html="icons.copy"></span>
                      </a>
                      <!-- copy -->
                    </div>

                    <button type="button" class="btn btn-icon btn-round btn-neutral"
                            :title="$t('message').article.share_text" slot="reference">
                    <span style=" fill:#39B8EB;" v-html="icons.share">
                    </span>
                    </button>
                  </el-popover>

                </div>
              </div>

              <div class="wcontent">
                <div class="content" id="articleContent" v-if="!show_editor"
                     v-html="$options.filters.textTrans(articleDetail.data.postInfo_postID.msgbody)">
                  <!-- group 帖子正文 -->
                </div>
                <!-- Editor -->
                <div class="border-bottom updateEditor" v-if="show_editor">
                  <wxc-editor :data="articleDetail.data" :action="'edit'" @submited="updated($event)"
                              @cancled="closeEditor()"></wxc-editor>
                </div>
                <!-- Editor-->
              </div>
            </div>
            <div class="mb-3" v-if="!show_editor">
              <TagBar :tags="articleDetail.data.postInfo_postID.tags">
              </TagBar>
            </div>
          </div>
          <div class="bg-content">
            <div class="comment mt-2" v-if="articleDetail.data.is_comment && $store.state.group.groupTopBar.auth>0 || $store.state.group.groupTopBar.is_private===0">
              <!-- <textarea type="textarea" v-model="replymsgbody" rows="3" class="w-100 mt-2 p-2"
                :placeholder="$t('message').article.comment_placeholder" @keyup="checkstatus"></textarea> -->

              <!--            <n-button v-if="!show_comment"-->
              <!--                      type="primary"-->
              <!--                      round-->
              <!--                      simple-->
              <!--                      @click="show_comment=true">{{ $t('message').article.comment_button }}-->
              <!--            </n-button>-->
              <h5 class="title mt-0 mb-3 text-secondary align-middle d-flex"><i
                  class="el-icon-chat-line-square mr-2 h2 mb-0"></i>发评论</h5>
              <div class="commentEditor" v-if="show_comment">
                <wxc-editor :data="articleDetail.data" :action="'comment'"
                            v-on:submited="show_comment=true"></wxc-editor>
              </div>
              <h5 class="commentlable text-secondary">
                {{ $t('message').article.comment_text }}（{{ articleDetail.data.countinfo_postID.count_comment }}）</h5>

            </div>
            <div v-else><p class="text-muted">非公开群吧 请先加入后再评论</p></div>
            <!-- <div v-if="!$store.state.group.article_view_comment.status" class="text-center">{{$store.state.group.article_view_comment.error}}</div> -->
            <div v-infinite-scroll="getComment"
                 infinite-scroll-disabled="disabled"
                 infinite-scroll-distance="50">
              <comment
                  v-for="item in $store.state.group.article_view_comment.data"
                  :key="item.postID"
                  :data="item"
                  :author="articleDetail.data.userID"
                  @regetcomment="rewrite"
                  @opendialog="$refs.dialog.isLogin()"
                  class="overflow-hidden"
              ></comment>
            </div>
            <!--            <div class="text-center py-5" v-if="loading.comment">&lt;!&ndash; loader &ndash;&gt;-->
            <!--              <i class="now-ui-icons loader_refresh spin"></i>-->
            <!--            </div>-->
            <p class="text-center text-primary bold py-4" style="cursor:pointer;font-weight: 500"
               v-if="!$store.state.group.article_view_comment.nomore"
               @click="getComment">
              点击查看更多评论<i style="font-weight: 700;font-size: 18px" class="el-icon-arrow-down ml-3"></i></p>
            <!--            <div class="text-center py-5" v-show="$store.state.group.article_view_comment.data.length>19">&lt;!&ndash; loader &ndash;&gt;-->
            <!--              <i class="now-ui-icons loader_refresh spin"></i>-->
            <!--            </div>-->
            <div v-show="this.noMore || $store.state.group.article_view_comment.data.length<19" class="nomore">-- 没有更多内容 --</div>
          </div>
        </div>
      </div>
    </div>
    <login-dialog ref="dialog"></login-dialog>
    <el-dialog
        :title="'共'+buzz_list.length+'人点赞'"
        :visible.sync="buzzListTrigger"
        width="370px"
        center>
      <div style="max-height:400px;overflow-y:auto">
        <member-list-item v-for="item in buzz_list" :data="item" :key="item.userID" type="small"
                          @opendialog="$refs.dialog.isLogin()">

        </member-list-item>
      </div>
    </el-dialog>
  </div>

</template>
<script>
import WxcEditor from '../editor/index.vue';
import {formatDate} from '@/directives/formatDate.js';
import {textTrans} from '@/directives/textTrans.js';
import MainMenu from '../components/Main/MainMenu';
import MemberListItem from '../components/Main/MemberListItem';
import {Button} from '@/components';
import icons from "@/components/Icons/Icons";
import Comment from './Comment';
import MainNavbar from '@/layout/MainNavbar.vue';
// import group from '@/module/group/group.service'
import {Checkbox, CheckboxButton, CheckboxGroup, Popover} from 'element-ui';
import LoginDialog from '../../../user/login/LoginDialog.vue';
import group from '@/module/group/group.service'
import LeftBar from '@/module/group/user/group/LeftBar.vue';
import TagBar from './TagBar';
import GroupHeader from '@/module/group/pages/components/group/GroupHeader';
import QrcodeVue from 'qrcode.vue'
// import UserInforCard from '@/module/user/components/UserInforCard'

export default {
  name: 'article-page',
  components: {
    WxcEditor,
    MainMenu,
    LeftBar,
    MemberListItem,
    GroupHeader,
    MainNavbar,
    // grouperListItem,
    // RecommendListItem,
    Comment,
    TagBar,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxButton.name]: CheckboxButton,
    [CheckboxGroup.name]: CheckboxGroup,
    [Popover.name]: Popover,
    LoginDialog,
    QrcodeVue,
    // UserInforCard,
    // groupHelp
  },
  watch: {
    '$store.state.group.article_view': function (val) {
      this.formatData(this.$store.state.group.article_view);
      this.formateTaglist(val);
    },
    '$route': function (val) {
      this.init();
    }
  },
  created() {
    this.init();
  },
  mounted: function () {
    this.getLikes();
  },
  computed: {
    disabled() {
      // return this.loading.comment || this.noMore
      return this.loading || this.noMore
    },
  },
  methods: {
    getComment() {
      this.lastID = !!this.$store.state.group.article_view_comment.data ? this.$store.state.group.article_view_comment.data[this.$store.state.group.article_view_comment.data.length -1 ].lastID: 0;
      this.$store.dispatch('group/GetArticalViewComment', {
        id: this.$route.query.postID,
        lastID: this.$store.state.group.article_view_comment.lastID
      })
    },
    init() {
      this.$store.dispatch('group/setActiveGroupID', this.$route.params.groupid);
      this.$store.dispatch('group/getGroupInfo', this.$route.params.groupid);
      this.$store.dispatch('group/GetArticalViewComment', {
        id: this.$route.query.postID,
        lastID: 0
      })
      this.$store.dispatch('group/GetArticalView', this.$route.query.postID).then(r => {
        this.formateTaglist(r.data);
        this.$store.dispatch('group/GetGroupTopic', this.$route.params.groupid).then(res => {
          if (!res.error) {
            //初始化群话题
            this.tags = res.data;
          } else {
            this.$message.error(res.error)
          }
        })
      });
    },
    formateTaglist(res) {
      //初始化帖子标签数组
      this.tagsList = [];
      if (res.postInfo_postID) {
        res.postInfo_postID.tags.forEach(x => {
          this.tagsList.push(x.id)
        });
      }
    },
    article_sticky(postID, type) {
      const params = {
        postID: postID,
        is_sticky: type,
        is_publish: type
      }
      this.$store.dispatch('group/setArticalSticky', params).then(res => {
        if (res.status) {
          this.articleDetail.data.is_sticky = type;
          // this.articleDetail.data.is_publish = type;
          // this.$store.dispatch('group/setArticalPublish', params);
          this.$message.success(type ? '成功转至推广贴！' : '成功从推广贴页撤下!');

        }
      }).catch(err => {
        this.$message.error('操作失败！')
      })
      // this.article_sticky(postID).then(res => {
      //   this.$message.success('成功转至推广贴！');
      // }).catch(err => {
      //     this.$message.error('操作失败！')
      //   })
    },
    changeTopic(tagID) {
      const params = {
        postID: this.articleDetail.data.postID,
        tagID: this.tagsList.toString()
      }

      this.$store.dispatch('group/changTopic', params).then(res => {
        if (res.status) {
          this.$store.dispatch('group/GetArticalView', this.$route.query.postID).then(res => {
            this.centerDialogVisible = false;
            this.formateTaglist(res.data)
          });
        }
      })
    },
    setTitle() {
      document.title = this.shareItem.title
    },
    formatData(res) {
      this.articleDetail = res;
      if (res.status) {
        let descrip = res.data.postInfo_postID.msgbody
        this.shareItem.title = res.data.postInfo_postID.title;
        this.shareItem.description = descrip.replace(/<[^>]+>/g, "").substr(0, 100);
        this.getComment();
        this.hasTw();
        this.setTitle();
      }
    },
    updated(res) {
      this.$store.dispatch('group/GetArticalView', this.$route.query.postID).then(r => {
        this.show_editor = false;
      })
    },
    closeEditor() {
      this.show_editor = false
    },
    getLikes() {
      let postid = this.$route.query.postID;
      group.article_buzz_list(postid).then(res => {
        this.buzz_list = res.status ? res.data : ''
      })
    },
    reply_add() {
      if (this.$refs.dialog.isLogin()) {
        let obj = {
          article_data: {
            msgbody: this.wrapToBr(this.replymsgbody),
            postID: this.articleDetail.data.postID,
            typeID: 1
          }
        }
        this.replybtndisable = true;
        group.reply_add(obj).then(res => {
          this.replybtndisable = false;
          if (res.status) {
            this.getFirst20();
            this.$message.success('话题创建成功!');
          } else {
            this.$message.error(res.error)
          }

          this.replymsgbody = "";
        })
      }
    },
    checkstatus() {
      this.replybtndisable = this.replymsgbody ? false : true;
    },
    getFirst20() {
      this.lastID = 0;
      this.comment = [];
      this.getComment();
    },

    rewrite(id) {
      if (!id) {
        this.comment.splice(0, 1)
      }
      group.article_view_comment_one(id).then(res => {
        this.comment.forEach(obj => {
          if (obj.postID == id) {
            let idx = this.comment.indexOf(obj);
            this.comment.splice(idx, 1, res.data)
          }
        })
      })
    },
    like() {
      if (!this.check_user_login()) return;
      if (this.articleDetail.data.postInfo_postID.is_buzz == 0) {
        this.buzz_add(this.articleDetail.data);
      } else {
        this.buzz_delete(this.articleDetail.data);
      }
    },
    buzz_add(item) {
      group.buzz_add(item.postID).then(res => {
        if (res.status) {
          this.articleDetail.data.postInfo_postID.is_buzz = 1
        }
      })
    },
    buzz_delete(item) {
      group.buzz_delete(item.postID).then(res => {
        if (res.status) {
          this.articleDetail.data.postInfo_postID.is_buzz = 0
        }
      })
    },
    // 收藏
    bookmark() {
      if (!this.check_user_login()) return;
      this.articleDetail.data.postInfo_postID.is_bookmark ? this.bookmark_delete(this.articleDetail.data) : this.bookmark_add(this.articleDetail.data)
    },
    bookmark_add(item) {
      group.bookmark_add(item.postID).then(res => {
        if (res.status) this.articleDetail.data.postInfo_postID.is_bookmark = 1;
      })
    },
    bookmark_delete(item) {
      group.bookmark_delete(item.postID).then(res => {
        if (res.status) this.articleDetail.data.postInfo_postID.is_bookmark = 0;
      })
    },
    gotoEditor() {
      this.show_editor = true
    },
    article_delete(item) {
      group.article_delete(item.postID, 0).then(res => {
        if (res.status) {
          this.$router.go(-1)
          this.$message.success('帖子已删除!');
        }
      })
    },
    admin_delete(item, type) {
      this.$store.state.user.admin_article_delete(item.postID, type).then(res => {
        if (res.status) {
          item.visible = type;
          // this.$message.success('帖子已删除!');
        }
      })
    },
    admin_delete_user(userID, status) {
      this.$store.state.user.user_delete(userID, status).then(res => {
        if (res.status) {
          this.$message.success('该用户已被封禁！')
        }
      })
    },
    admin_add2wxc(postID) {
      this.$store.state.user.wxc_hot_blog_add(postID).then(res => {
        this.check_iswxc_hot(postID);
        this.$message.success('该帖子推荐成功！');
      })
          .catch(err => {
            this.$message.error('操作失败！')
          })
    },
    admin_delete_wxc(postID) {
      this.$store.state.user.wxc_hot_blog_delete(postID).then(res => {
        this.check_iswxc_hot(postID);
        this.$message.success('已从文学城首页撤下！');
      })
          .catch(err => {
            this.$message.error('操作失败！')
          })
    },
    // check_iswxc_hot(postID) {
    //   this.$store.state.user.wxc_hot_blog_check(postID).then(res => {
    //     this.articleDetail.data.is_wxc_hot = res.data;
    //     this.$forceUpdate();
    //   })
    //       .catch(err => {
    //         console.log(err)
    //       })
    // },

    // user_login_wxc_to_haiwai(token) {
    //   let user = this.$store.state.user;
    //   if (this.token && !user.userinfo.id) {
    //     user.user_login_wxc_to_haiwai(token).then(res => {
    //       user.getUserInfo(this.$route.params.id).then(res => {
    //         this.$router.push('/group/p/' + this.$route.params.id)
    //       })
    //     })
    //   } else {
    //     this.$router.push('/group/p/' + this.$route.params.id)
    //   }
    // },
    wrapToBr(text) {
      var string = text;
      try {
        string = string.replace(/\r\n/g, "<br>")
        string = string.replace(/\n/g, "<br>");
        string = string.replace(/\r/g, "<br>");
        string = string.replace(/\s/g, "&nbsp;");
      } catch (e) {
      }
      return string;
    },
    hasTw() {
      var content = this.articleDetail.data.postInfo_postID.msgbody
      if (content) {
        if (content.indexOf("twitter-tweet") !== -1) {
          this.addTw();
        }
      }
    },
    addTw() {
      let script = document.getElementById('hasTw');
      if (!script) {
        script = document.createElement('script');
        script.id = 'hasTw';
        script.src = 'https://platform.twitter.com/widgets.js';
        script.charset = 'utf-8';
        document.body.append(script);
      }
    },
    copyUrl() {
      var oInput = document.createElement("input"); //创建隐形input
      oInput.value = window.location.href; // window.location.href 浏览器URL
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message.success("本文链接已复制成功！");
      this.share.showShareBar = false;
    },
  },
  data() {
    return {
      tags: [],
      article_tags: [],
      show_comment: true,
      tagsList: [],
      show_editor: false,
      userID: this.$store.state.user.userinfo.id,
      groupinfoID: 1,
      topicID: [],
      groupState: this.$store.state.group,
      length: 0,
      icons: icons,
      loginuserID: -1,
      showcomment: false,
      articleDetail: {},
      comment: [],
      replymsgbody: "",
      replybtndisable: true,
      lastID: 0,
      noMore: false,
      loading: false,
      share: {
        showShareBar: false,
        wechatQR: false
      },
      shareItem: {
        url: window.location.href,
        title: '',
        description: '',
        QRcode: `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${window.location.href}`
      },
      shareNetworks: [
        {
          network: 'line',
          icon: icons.line
        },
        {
          network: 'facebook',
          icon: icons.facebook
        }, {
          network: 'twitter',
          icon: icons.twitter
        },
        {
          network: 'weibo',
          icon: icons.weibo
        },
        {
          network: 'whatsapp',
          icon: icons.whatsapp
        }

      ],
      token: this.$route.query.token,
      buzz_list: [],
      buzzListTrigger: false,
      centerDialogVisible: false,

    };
  },
  filters: {
    // formatDate(time) {
    //   var date = new Date(time)
    //   var date = date.getFullYear() + "-" + ("0"+(date.getMonth()+1)).slice(-2) + "-" + ("0"+date.getDate()).slice(-2) + " " +
    //       ("0"+date.getHours()).slice(-2) + ":" + ("0"+date.getMinutes()).slice(-2);
    //   return date
    // },
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd hh:mm');
      //x=当前日期-create_date
      //x<86000 : hh
      //86000 < x < 86000 *30 : dd
      //86000 * 30 < x < 86000 *365 : MM
      //86000 *365 < X : yyyy YY yy
    },
    textTrans(string) {
      return textTrans(string);
    }
  }
};
</script>
<style>

.fontsize0 .content {
  font-size: 0.9rem;
}

.fontsize1 .content {
  font-size: 1.3rem;
}

.fontsize2 .content {
  font-size: 1.5rem;
}

.article-page .box {
  background-color: #f6f9fc;
  border-radius: 16px;
  padding: 10px 0
}

.article-page .trans {
  transform: rotate(90deg);
}

.article-page .el-icon-more.trans {
  color: #0485b9;
  font-weight: 800;
  font-size: 13px;
  border-radius: 50px;
  padding: 4px;
  border: 2px solid #0485b9;
  margin-top: 0;
  vertical-align: text-bottom;
}

.article-page .article span.el-avatar.el-avatar--circle {
  width: 35px !important;
  height: 35px !important;
  line-height: 35px !important;
}

/*.article-page .el-icon-more.trans{*/
/*  background-color:#fff;*/
/*  font-weight: 600;*/
/*  font-size: 18px;*/
/*  margin-left: 10px;*/
/*  padding: 10px;*/
/*}*/
.article-page .el-icon-more.trans:hover {
  /*background-color:#e7eae6;*/
  font-weight: 900;
}

.article-page .title {
  padding: 0 18px 0 0;
}

.article-page p {
  font-size: inherit
}

.article-page h5 {
  margin-top: 15px;
  font-weight: 400
}

.article-page .commentlable {
  border-bottom: #ddd 1px solid;
  padding: 10px 0;
  margin-bottom: 12px;
}

.article-page .comment textarea {
  border: #ddd 1px solid;
}

.comment .replyContent {
  /*width:680px;*/
  width: auto;
  word-break: break-all;
}

.commentEditor {
  height: 250px !important;
}

.updateEditor {
  height: 550px
}

.commentEditor .tox-tinymce, .updateEditor .tox-tinymce {
  height: calc(100% - 35px) !important;
}

/* r2 */
.shareIcons a:hover {
  text-decoration: none;
}

.shareIcon svg {
  width: 28px;
  height: 28px;
}

.article-page .hot-group {
  border-top: none !important;
  padding-left: 0;
  border-bottom: none;
}

.article-page h4 {
  margin-bottom: 0;
  font-size: 1.6em;
  margin-top: 0;
}

.article-page .content {
  padding-top: 1rem;
  padding-bottom: 1rem;
  word-break: break-all;
}

.article-page .content p img,
.article-page .content p iframe {
  width: 85%;
  margin: 0 auto;
  display: block;
}

.article-page .groupger-box {
  width: 122px
}

.article-page .media-icons .btn {
  font-size: 1.5rem !important;
  margin: -5px 0 0 0;
}

.buzz_list {
  font-size: 13px;
  cursor: pointer;
}

.article-page .wcontent {
  font-size: 1.3em;
  font-weight: 300;
  line-height: 1.8em;
  overflow: hidden
}

.article-page .el-checkbox__label {
  line-height: 42px;
  font-size: 17px;
}

.article-page .el-checkbox-group {
  text-align: center;
}
.article-page iframe{
  max-width: 690px;
}
.article-page .el-dropdown-menu__item {
  font-size: 16px;
}

@media (max-width: 575.98px) {
  .article-page .groupger-box {
    width: 220px
  }

  .article-page .content p img,
  .article-page .content p iframe {
    width: 100%;
  }

  .comment .replyContent {
    width: 370px
  }
}
</style>